import { restAPI } from "./index.ts";
import {
  type PluginSchemaType,
  type PluginGetListRequestType,
} from "../schemas/PluginSchemas.ts";
import {
  type GetListResponseType,
  type ResourceAdapterType,
} from "../util/index.ts";
import { fetchAndCollate, getFilterObject } from "../util/index.ts";

export interface PluginAdapterType
  extends Pick<ResourceAdapterType<PluginSchemaType>, "getList"> {
  /**
   * Search for plugins
   * @see https://staging-carbon-hub-api.s3.us-west-2.amazonaws.com/openapi/index.html#/plugins/search_plugins
   */
  getList: (
    params: PluginGetListRequestType
  ) => Promise<GetListResponseType<PluginSchemaType>>;
}

export const PluginAdapter: PluginAdapterType = {
  /**
   * Search for plugins
   * @see https://staging-carbon-hub-api.s3.us-west-2.amazonaws.com/openapi/index.html#/plugins/search_plugins
   */
  getList: ({
    page,
    pageSize,
    sortBy,
    sortDirection,
    filters,
  }: PluginGetListRequestType) =>
    fetchAndCollate<PluginSchemaType>(
      ({ page, pageSize }) =>
        restAPI.nodeAPI.POST<GetListResponseType<PluginSchemaType>>({
          endpoint: "/plugins/search",
          body: {
            page,
            page_size: pageSize,
            sort_by: sortBy,
            sort_direction: sortDirection,
            filter: getFilterObject(filters),
          },
        }),
      page,
      pageSize
    ),
};
